import moment from 'moment';
import { createActions, createReducer } from 'reduxsauce';

// Define Action
const { Types, Creators } = createActions({
  getPost: ['postId', 'classroomId'],
  getPostSuccess: null,
  getReplyList: ['postId', 'pageSize', 'beforeTime'],
  getReplyListSuccess: null,
  like: ['postId', 'targetId', 'targetType', 'agree'],
  likeSuccess: null,
  deleteReply: ['replyId'],
  deleteReplySuccess: null,
  getNewReplyCount: ['afterTime'],
  getNewReplyCountSuccess: null,
  toggleFold: ['isOpen'],
  saveParams: ['params'],
  setUrlParams: ['urlParams'],
  setUserInfo: ['userInfo'],
  setFtlData: ['ftlData'],
  nextPage: ['postId'],
  getReplyUserTotal: null,
  getReplyUserTotalSuccess: null,
  deleteComment: ['postId', 'commentId', 'replyId'],
  deleteCommentSuccess: null,
  deleteCommentFailed: null,
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const DEFAULT_PAGE_SIZE = 20;
const INITIAL_STATE = {
  // 讨论内容
  postContent: {},
  // 评论列表
  list: null,
  // 学生总数
  total: 0,
  // 新回复数量
  newReplycount: '',
  // 默认是否展开
  isOpen: false,
  isTeacher: true,
  // 折叠高度
  foldHeight: 200,
  // 是否需要引导
  needLikeGuide: true,
  // 是否需要评论区域
  showCommentArea: false,
  // 是否需要新增留言提示
  showNewReplyCount: true,
  urlParams: {},
  userInfo: {},
  ftlData: {},
  currentPageSize: DEFAULT_PAGE_SIZE,
  beforeTime: moment().valueOf(),
};
// Define Reducer
export default createReducer(INITIAL_STATE, {
  [Types.GET_POST_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    postContent: action.postContent,
  }),
  [Types.GET_REPLY_LIST]: (state = INITIAL_STATE, action) => ({
    ...state,
    beforeTime: action.beforeTime,
  }),
  [Types.GET_REPLY_LIST_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    total: action.total,
    list: action.list,
    currentPageSize:
      state.currentPageSize / DEFAULT_PAGE_SIZE > action.query.totlePageCount
        ? action.query.totlePageCount * DEFAULT_PAGE_SIZE
        : state.currentPageSize,
  }),
  [Types.GET_NEW_REPLY_COUNT_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    newReplyCount: action.newReplyCount,
  }),
  [Types.LIKE_SUCCESS]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      list: action.list,
    };
  },
  [Types.DELETE_REPLY_SUCCESS]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      list: action.list,
    };
  },
  [Types.TOGGLE_FOLD]: (state = INITIAL_STATE, action) => ({
    ...state,
    isOpen: action.isOpen,
  }),
  [Types.SAVE_PARAMS]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      ...action.params,
    };
  },
  [Types.SET_URL_PARAMS]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      urlParams: action.urlParams ?? {},
    };
  },
  [Types.SET_USER_INFO]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      userInfo: action.userInfo ?? {},
    };
  },
  [Types.SET_FTL_DATA]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      ftlData: action.ftlData ?? {},
    };
  },
  [Types.NEXT_PAGE]: (state = INITIAL_STATE) => {
    const { currentPageSize } = state;
    return {
      ...state,
      currentPageSize:
        (currentPageSize / DEFAULT_PAGE_SIZE + 1) * DEFAULT_PAGE_SIZE,
    };
  },
  [Types.GET_REPLY_USER_TOTAL_SUCCESS]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      total: action.total || 0,
    };
  },
  [Types.DELETE_COMMENT_SUCCESS]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      list: action.list,
    };
  },
  [Types.DELETE_COMMENT_FAILED]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      list: action.list,
    };
  },
});
